import { Component, JSX, Show } from "solid-js";
import { A } from "@solidjs/router";
import { useAuth } from "../App";

const ProtectedRoute: Component<{ children: JSX.Element; paid?: boolean }> = (props) => {
  const auth = useAuth();
  return (
    <Show when={!auth().loading} fallback={<div class="page-state"><span class="spinner" />Checking your access…</div>}>
      <Show when={auth().user_id} fallback={
        <div class="access-card"><span class="access-icon">→</span><h1>Sign in to continue</h1><p>Create a free account to access the race dashboard.</p><A class="button button-primary" href="/login?mode=signup">Create free account</A></div>
      }>
        <Show when={!props.paid || auth().is_paid} fallback={
          <div class="access-card"><span class="access-icon">◇</span><h1>Unlock the full signal</h1><p>This analysis is available to Pro members. Choose monthly or annual access to continue.</p><A class="button button-primary" href="/pricing">View Pro plans</A></div>
        }>{props.children}</Show>
      </Show>
    </Show>
  );
};

export default ProtectedRoute;
